<template>
<div class="chapter">
<div class="inner_page">
<p class="sp" id="pro"> </p>
<p class="CT-FM"><span href="#/xhtml/contents#c_pro" title="Link target outside of Sample"><span class="ePub-B">PROLOGUE </span></span><br/><span class="ePub-BI">Twelve Years Earlier</span></p>
<p class="Ezra">Ezra</p>
<p class="CO">Like a hundred years ago my mom asked me to watch my five-year-old brother Gideon while he played in the backyard. But then I got bored, because he’s a boring kid, and now I realize he’s not actually in the backyard anymore.</p>
<p class="TX">I need to find that little a-hole before my mom notices and I get in trouble for him going missing or whatever.</p>
<p class="TX">I can’t yell for him, though, and I can’t let my mom notice that I can’t find him, so I need to be super stealth about it. Like a ninja. On the other hand, if she comes outside and doesn’t see him, I can just say that we’re playing hide-and-seek. It’s good to have a plan.</p>
<p class="TX">I tiptoe around the yard, whispering his name.</p>
<p class="TX">I finally find him, all the way behind the garage, where he’s not supposed to play because it’s so close to the woods and the highway behind the woods. Our dad says they need to build a wall by the highway, but they haven’t yet. That’s why Gideon isn’t allowed back there. I’m technically not allowed back there either. But I’m almost eleven, and I make my own decisions.</p>
<p class="TX">“You’re not supposed to be back here,” I say when I find him. He’s playing in the dirt with some tiny little blond kid who looks at me like I’m trying to kidnap him or something.</p>
<p class="TX">“I made a friend,” Gideon says, pointing at the blond kid.</p>
<p class="TX">The kid stands up and stares at me.</p>
<p class="TX">“What’s his name?” I ask. Maybe Gideon found a runaway. Maybe there’s a huge reward for this kid. Gideon’s young and dumb and I could keep most of the money and just buy him some toys. He’d never know the difference.</p>
<p class="TX">“He didn’t tell me,” Gideon says as he stands up. He takes the other boy’s hand protectively.</p>
<p class="TX">“Are you lost?” I ask him.</p>
<p class="TX">He squeezes Gideon’s hand and shakes his head. He points toward the house next door.</p>
<p class="TX">“Did you just move here?” I ask.</p>
<p class="TX">He nods a whole bunch of times in a row.</p>
<p class="TX">“You should go home,” I tell him.</p>
<p class="TX">His eyes go wide and he runs in the direction of his house, which probably seems a lot farther away than it really is, since the kid’s so tiny.</p>
<p class="TX">“Good-bye, new friend!” Gideon yells after him, waving.</p>
<p class="TX">“I’m gonna tell Mom that you were behind the garage and she’s gonna be so pissed at you!” I tell Gideon as we walk toward the house.</p>
<p class="TX">“I’m gonna tell Mom you said a bad word,” Gideon answers.</p>
<p class="TX">He’s too smart for a five-year-old.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// prologue.vue?69f7c76b